import React from 'react';
import tickGreen from '../../image/tick-green.svg';

export default function FillInfoSuccessPage() {
    return (
        <div style={{ 
            minHeight: '50vh', 
            display: 'flex', 
            alignItems: 'flex-start', 
            justifyContent: 'center',
            padding: '2rem 1rem',
            backgroundColor: 'transparent'
        }}>
            <div style={{ 
                // borderRadius: '10px', 
                // boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.1)', 
                // backgroundColor: 'white', 
                padding: '3rem 2rem', 
                width: '100%',
                maxWidth: '800px'
            }}>
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    textAlign: 'center' 
                }}>
                    <div style={{ marginBottom: '2rem' }}>
                        <img 
                            src={tickGreen} 
                            alt="success" 
                            style={{ width: '64px', height: '64px' }} 
                        />
                    </div>
                    
                    <h2 style={{ 
                        fontSize: '1.75rem', 
                        fontWeight: '700', 
                        color: '#131313', 
                        marginBottom: '1.5rem',
                        fontFamily: 'IRANYekanX',
                        margin: '0 0 1.5rem 0'
                    }}>
                        اطلاعات شما با موفقیت ارسال شد.
                    </h2>
                    
                    <p style={{ 
                        color: '#4D4D4D', 
                        fontSize: '1.125rem', 
                        lineHeight: '1.75',
                        fontFamily: 'IRANYekanX',
                        margin: 0
                    }}>
                        به زودی پس از تایید کارشناسان از طریق پیامک{' '}
                        <span style={{ 
                            textDecoration: 'underline', 
                            color: '#044448', 
                            fontWeight: '700',
                            textUnderlineOffset: '0.5rem'
                        }}>
                            جهت ادامه فرایند
                        </span>{' '}
                        اطلاع رسانی خواهد گردید.
                    </p>
                </div>
            </div>
        </div>
    );
}

